import flatpickr from 'flatpickr';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
flatpickr('.js-datepicker', { locale: Japanese, enableTime: false, dateFormat: 'Y-m-d' });
